const getters = {
  getListPendingJobsEmployer: state => state.listPendingJobsEmployer,
  getListCurrentOfferJobs: state => state.listCurrentOfferJobs,
  getListOngoingJobsEmployer: state => state.listOngoingJobsEmployer,
  getListApprovedJobsEmployer: state => state.listApprovedJobsEmployer,
  getListCompletedJobsEmployer: state => state.listCompletedJobsEmployer,
  getListSearchJobsEmployer: state => state.listSearchJobsEmployer,
  getTotalJobsEmployer: state => state.totalJobsEmployer,
  getListOngoingJobsTalent: state => state.listOngoingJobsTalent,
  getListPendingJobsTalent: state => state.listPendingJobsTalent,
  getListCompletedJobsTalent: state => state.listCompletedJobsTalent,
  getTotalJobsTalent: state => state.totalJobsTalent,
  getSubmittedJobInfo: state => state.submittedJobInfo,
  getInvoiceList: state => state.invoiceList

}

export default getters
